// @ts-check
import characterNoNotifications from 'images/characters/character-no-notifications.svg';
import { Flex } from 'components/base/layout-components';
import * as LighthouseService from 'common/services/lighthouse.service';
import { ARTICLE_IDS } from 'common/constants/constants';
import Text from 'components/base/Text';
import { SPACES } from 'common/constants/sizes';
import { LBButton } from '@linearb/buzz';

const NotConnected = ({ chatTool, children }) => (
  <Flex
    pt='large'
    pb='x-large'
    direction='column'
    width='100%'
    items='center'
    justify='center'
  >
    <img src={characterNoNotifications} alt='' />
    <Flex items='center' pt='medium' pb='medium'>
      <Text size='medium' pr={SPACES['x-x-small']} color='shuttleGray'>
        Connect your team {chatTool} channel to receive real time notifications
      </Text>
      <Text size='medium'>
        <LBButton
          variant='ghost'
          onClick={() =>
            LighthouseService.navigateArticle(ARTICLE_IDS.CONNECT_SLACK)
          }
        >
          Learn more
        </LBButton>
      </Text>
    </Flex>
    {children}
  </Flex>
);

export default NotConnected;
